<template>
    <div class="pub-page">
        <div class="top-card">
            <div class="project-info">
                <span class="info-item">
                    <span class="info-label">招标项目名称：</span>
                    <span class="info-value">{{ projectName }}</span>
                </span>
                <span class="info-sep"></span>
                <span class="info-item">
                    <span class="info-label">招标项目编号：</span>
                    <span class="info-value">{{ projectCode }}</span>
                </span>
            </div>
            <div class="top-actions">
                <el-button class="btn-primary" @click="handleAdd(1)">
                    <i class="el-icon-plus"></i> 新增中标公告
                </el-button>
                <el-button class="btn-back" @click="handleBack">
                    <i class="el-icon-arrow-left"></i> 返回
                </el-button>
            </div>
        </div>

        <div class="table-card">
            <div class="table-header">
                <span class="header-title">中标公告列表</span>
            </div>
            <el-table :data="tableData" border class="data-table" v-loading="loading">
                <el-table-column label="NO." width="60" align="center">
                    <template slot-scope="scope">{{ (query.current - 1) * query.size + scope.$index + 1 }}</template>
                </el-table-column>
                <el-table-column prop="winBulletinName" label="公告标题" show-overflow-tooltip />
                <el-table-column prop="bidSectionName" label="标段名称" show-overflow-tooltip />
                <el-table-column prop="typeCode" label="公告性质" width="100" align="center">
                    <template slot-scope="scope">
                        {{ typeCodeText(scope.row.typeCode) }}
                    </template>
                </el-table-column>
                <el-table-column prop="publicTime" label="发布时间" width="160" align="center" />
                <el-table-column prop="status" label="状态" width="100" align="center">
                    <template slot-scope="scope">
                        <span class="status-tag" :class="`status-tag--${getStatusType(scope.row.status)}`">
                            {{ getStatusText(scope.row.status) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="auditOpinion" label="审核意见" min-width="150" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.status === 2">{{ scope.row.auditOpinion }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="190" align="center" fixed="right">
                    <template slot-scope="scope">
                        <el-button type="text" class="action-btn" @click="handleDetail(scope.row)" v-if="scope.row.status === 1 || scope.row.status === 9">查看</el-button>
                        <el-button type="text" class="action-btn" @click="handleEdit(scope.row)" v-if="scope.row.status === 0 || scope.row.status === 2">编辑</el-button>
                        <el-button type="text" class="action-btn action-btn--danger" @click="handleDelete(scope.row)" v-if="scope.row.status === 0 || scope.row.status === 2">删除</el-button>
                        <el-button type="text" class="action-btn" @click="handleChange(scope.row)" v-if="scope.row.status === 9">变更公告</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-wrap" v-if="total > 0">
                <el-pagination
                    background
                    layout="total, prev, pager, next, jumper"
                    :total="total"
                    :page-size="query.size"
                    :current-page="query.current"
                    @current-change="handlePageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetWinBulletinSemiList, Api_DeleteWinBulletinSemi } from '@/api/modules/semiProcess'

export default {
    name: 'BidWinAnnouncement',

    data() {
        return {
            projectName: '',
            projectCode: '',
            tableData: [],
            total: 0,
            loading: false,
            query: {
                current: 1,
                size: 10,
                projectCode: ''
            }
        }
    },

    created() {
        this.projectName = this.$route.query.projectName || ''
        this.projectCode = this.$route.query.projectCode || ''
        this.query.projectCode = this.projectCode
        this.loadData()
    },

    methods: {
        loadData() {
            this.loading = true
            Api_GetWinBulletinSemiList(this.query).then(res => {
                this.loading = false
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.total = res.data.total || 0
                    this.query.current = res.data.current || 1
                    this.query.size = res.data.size || 10
                } else {
                    this.$message.error(res.msg || '获取数据失败')
                }
            }).catch(() => {
                this.loading = false
            })
        },

        typeCodeText(typeCode) {
            const map = { 1: '正常公告', 2: '更正公告' }
            return map[typeCode] || '-'
        },

        getStatusType(status) {
            const map = { 0: 'info', 1: 'warning', 2: 'danger', 9: 'success' }
            return map[status] || 'info'
        },

        getStatusText(status) {
            const map = { 0: '暂存', 1: '提交', 2: '退回', 9: '发布' }
            return map[status] || '-'
        },

        handleBack() {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: { projectName: this.projectName, projectCode: this.projectCode }
            })
        },

        handleAdd(typeCode) {
            this.$router.push({
                path: '/agentHome/bidWinAnnouncementEdit',
                query: {
                    projectName: this.projectName,
                    projectCode: this.projectCode,
                    typeCode: typeCode,
                    mode: 'add'
                }
            })
        },

        handleDetail(row) {
            this.$router.push({
                path: '/agentHome/bidWinAnnouncementDetail',
                query: {
                    projectName: this.projectName,
                    projectCode: this.projectCode,
                    winBulletinCode: row.winBulletinCode
                }
            })
        },

        handleEdit(row) {
            this.$router.push({
                path: '/agentHome/bidWinAnnouncementEdit',
                query: {
                    projectName: this.projectName,
                    projectCode: this.projectCode,
                    winBulletinCode: row.winBulletinCode,
                    typeCode: row.typeCode,
                    mode: 'edit'
                }
            })
        },

        handleDelete(row) {
            this.$confirm('确定删除该公告？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Api_DeleteWinBulletinSemi({ winBulletinCode: row.winBulletinCode }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.loadData()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                })
            }).catch(() => {})
        },

        handleChange(row) {
            this.$router.push({
                path: '/agentHome/bidWinAnnouncementEdit',
                query: {
                    projectName: this.projectName,
                    projectCode: this.projectCode,
                    originalWinBulletinCode: row.winBulletinCode,
                    typeCode: 2,
                    mode: 'change'
                }
            })
        },

        handlePageChange(page) {
            this.query.current = page
            this.loadData()
        }
    }
}
</script>

<style lang="less" scoped>
.pub-page { background: #F2F4F7; min-height: 100vh; padding: 20px 16px; }
.top-card { margin: 0 auto 16px; display: flex; align-items: center; justify-content: space-between; background: #fff; border-radius: 4px; padding: 14px 20px; flex-wrap: wrap; gap: 12px; }
.project-info { display: flex; align-items: center; flex-wrap: wrap; }
.info-item { font-size: 14px; }
.info-label { color: #606266; }
.info-value { color: #303133; font-weight: 500; }
.info-sep { width: 1px; height: 16px; background: #DCDFE6; margin: 0 16px; }
.top-actions { display: flex; gap: 10px; flex-wrap: wrap; }
.btn-primary { background: #1890FF; border-color: #1890FF; color: #fff; border-radius: 4px; font-size: 14px; i { margin-right: 4px; } &:hover { background: #40A9FF; border-color: #40A9FF; } }
.btn-back { background: #fff; border-color: #DCDFE6; color: #606266; border-radius: 4px; font-size: 14px; i { margin-right: 4px; } &:hover { color: #409EFF; border-color: #409EFF; } }
.table-card { margin: 0 auto; background: #fff; border-radius: 4px; }
.table-header { padding: 14px 20px; border-bottom: 1px solid #EBEEF5; }
.header-title { font-size: 14px; font-weight: 600; color: #303133; }
.data-table { border: none; border-radius: 0; /deep/ .el-table__header-wrapper th { background: #FAFAFA; color: #606266; font-weight: 500; font-size: 13px; } /deep/ .el-table__cell { padding: 13px 0; font-size: 13px; color: #606266; } }
.status-tag { display: inline-block; padding: 2px 8px; border-radius: 2px; font-size: 12px; border: 1px solid; &--success { color: #67C23A; border-color: #c2e7b0; background: #f0f9eb; } &--warning { color: #E6A23C; border-color: #faecd8; background: #fdf6ec; } &--info { color: #909399; border-color: #d3d4d6; background: #f4f4f5; } &--danger { color: #F56C6C; border-color: #fbc4c4; background: #fef0f0; } }
.action-btn { color: #409EFF; font-size: 13px; padding: 0 4px; &--danger { color: #F56C6C; } }
.pagination-wrap { display: flex; justify-content: flex-end; padding: 14px 16px; border-top: 1px solid #EBEEF5; }
</style>
